import { e as error } from "../../../chunks/index.js";
class PostArray {
  posts;
  constructor(posts) {
    this.posts = posts;
  }
  appendSections(sections) {
    return this.posts.map((post) => ({
      ...post,
      sections: sections.filter((el) => el.post === post.id)
    }));
  }
  replaceTagIdsWithNames(tags) {
    const tagMap = {};
    tags.forEach((tag) => {
      tagMap[tag.id] = tag.name;
    });
    return this.posts.map((post) => ({
      ...post,
      tags: post.tags.map((tagId) => {
        const tag = tags.find((tag2) => tag2.id === tagId);
        return tag ? tag.name : null;
      })
    }));
  }
  createSearchTerms() {
    return this.posts.map((post) => ({
      ...post,
      searchTerms: `${post.title} ${post.description} ${post.content} ${post.sections?.map((section) => section.subtitle)} ${post.sections?.map((section) => section.content_1)} ${post.sections?.map((section) => section.content_2)} ${post.sections?.map((section) => section.image_alt)} ${post.tags.map((tag) => tag)}`
    }));
  }
  getPostById(id) {
    return this.posts.find((post) => post.id === id);
  }
  getPostsByTag(tag) {
    return this.posts.filter((post) => post.tags.includes(tag));
  }
  getPublishedPosts() {
    return this.posts.filter((post) => post.published);
  }
  getUnpublishedPosts() {
    return this.posts.filter((post) => !post.published);
  }
}
const load = async ({ fetch }) => {
  let res;
  try {
    res = await fetch(`https://admin.firstlandings.com/api/blog/posts`);
    const posts = new PostArray(await res.json());
    res = await fetch(`https://admin.firstlandings.com/api/blog/sections`);
    const sections = await res.json();
    posts.appendSections(sections);
    res = await fetch(`https://admin.firstlandings.com/api/blog/post-tags`);
    const tags = await res.json();
    posts.replaceTagIdsWithNames(tags);
    return { posts };
  } catch (e) {
    throw error(500, `${e}`);
  }
};
export {
  load
};
